<button type="button" class="bk-more bb" (click)="back.emit()">
  <span class="bk-sym" aria-hidden="true">arrow_back</span>
  <span>{{ label }}</span>
</button>
